module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.header))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d864c826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/SimpleMenu.vue
// module id = 287
// module chunks = 0